module.exports = __webpack_public_path__ + "static/media/carclinic_logo.f5a34739.png";